import _taggedTemplateLiteral from "/var/lib/jenkins/workspace/familjecentralenpaletten.staffanstorp.se/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import { css, jsx } from "@emotion/react";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import { filterAttributes } from "../utils";
import * as defaultStyles from "./PageGrid.module.css";
PageGridItem.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.node,
  className: PropTypes.string,
  styles: PropTypes.objectOf(PropTypes.string)
};
export default function PageGridItem(_a) {
  var _b = _a,
    {
      as: Component = "div",
      colSpan,
      children,
      className,
      styles = defaultStyles
    } = _b,
    restProps = __objRest(_b, ["as", "colSpan", "children", "className", "styles"]);
  let attributes = typeof Component === "string" ? filterAttributes(restProps) : restProps;
  return /* @__PURE__ */jsx(Component, __spreadValues({
    css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        --page-grid-columns: ", ";\n      "])), colSpan || null),
    className: clsx(styles.item, className)
  }, attributes), children);
}